@let i18n = translate();
@let testIdPrefix = 'rcp-vendor-supplier';

@if (isBusy()) {
    <app-spinner-loader [message]="i18n.FetchingYourInfo"></app-spinner-loader>
} @else {
    <div class="rcp-px-6 rcp-pt-6">
        <app-content-header></app-content-header>
        <button
            mat-button
            class="rcp-my-4"
            [attr.data-testid]="'back-btn' | testid: testIdPrefix"
            (click)="onBack($event)"
        >
            <div class="rcp-inline-flex rcp-items-center">
                <mat-icon class="rcp-mr-2 !rcp-h-[18px] !rcp-w-[18px] !rcp-text-lg/[18px]"
                    >arrow_back</mat-icon
                >
                {{ i18n.Back }}
            </div>
        </button>
        <div class="rcp-flex rcp-flex-row rcp-gap-6">
            <div
                class="rcp-w-full rcp-max-w-[280px]"
                [attr.data-testid]="'company-details' | testid: testIdPrefix"
            >
                <div
                    class="rcp-flex rcp-h-[calc(100vh-74px)] rcp-flex-col rcp-rounded-large rcp-border-[1px] rcp-border-ul-gray-400 rcp-p-4"
                >
                    <div
                        class="rcp-mb-4 rcp-flex rcp-flex-row rcp-items-start rcp-justify-between"
                    >
                        @if (showAvatarInitials()) {
                            <div
                                class="rcp-inline-flex rcp-h-[64px] rcp-w-[64px] rcp-items-center rcp-justify-center rcp-rounded-full rcp-bg-ul-red-400 rcp-text-xl rcp-text-white"
                                [attr.data-testid]="
                                    'company-details-logo-placeholder'
                                        | testid: testIdPrefix
                                "
                            >
                                {{ companyInitials() }}
                            </div>
                        } @else {
                            <img
                                class="rcp-mb-5 rcp-inline-block rcp-size-16 rcp-rounded-full rcp-border-[1px] rcp-border-ul-gray-400"
                                alt="Company Logo"
                                [src]="companyImageUrl()"
                                [attr.data-testid]="
                                    'company-details-logo' | testid: testIdPrefix
                                "
                                (error)="onImageError()"
                            />
                        }
                        <!-- NOTE Enable this once PBI ready on Edit Client features -->
                        <!-- <button
                                mat-icon-button
                                class="-rcp-mr-3 -rcp-mt-3 !rcp-inline-flex"
                                [attr.data-testid]="
                                    'company-details-edit-btn' | testid: testIdPrefix
                                "
                            >
                                <mat-icon>edit</mat-icon>
                            </button> -->
                    </div>

                    <h1
                        class="rcp-mb-3 rcp-font-poppins rcp-text-[22px]/9 rcp-font-normal rcp-text-ul-dark-400"
                        [attr.data-testid]="'company-details-name' | testid: testIdPrefix"
                    >
                        {{ companyName() }}
                    </h1>

                    <ul class="rcp-flex rcp-list-outside rcp-flex-col rcp-gap-2">
                        @for (company of companyInfo(); track company.id) {
                            <li
                                class="rcp-flex rcp-items-center rcp-gap-2 rcp-text-[12px]/9 rcp-font-normal rcp-text-ul-dark-400"
                            >
                                <mat-icon
                                    class="!rcp-h-4 !rcp-w-4 rcp-flex-shrink-0 !rcp-text-base/4 rcp-text-ul-blue-400"
                                    [attr.data-testid]="
                                        company.testId + '-icon' | testid: testIdPrefix
                                    "
                                    >{{ company.icon }}</mat-icon
                                >
                                <span
                                    class="rcp-break-all rcp-leading-tight"
                                    [attr.data-testid]="
                                        company.testId | testid: testIdPrefix
                                    "
                                    >{{ company.value }}</span
                                >
                            </li>
                        }
                    </ul>

                    <hr class="rcp-my-6" />
                    <div class="rcp-mb-3">
                        <h3
                            class="rcp-mr-2 rcp-inline-block rcp-text-base/5 rcp-font-medium rcp-text-ul-dark-400"
                            [attr.data-testid]="
                                'company-details-username' | testid: testIdPrefix
                            "
                        >
                            {{ userName() }}
                        </h3>
                        <span
                            class="rcp-inline-block rcp-rounded-full rcp-bg-ul-blue-200 rcp-px-3 rcp-py-[2px] rcp-text-[11px]/4 rcp-font-semibold rcp-text-ul-blue-600"
                            [attr.data-testid]="
                                'company-details-username-role' | testid: testIdPrefix
                            "
                        >
                            {{ userRole() }}
                        </span>
                    </div>

                    <ul class="rcp-flex rcp-list-outside rcp-flex-col rcp-gap-2">
                        @for (admin of primaryAdminInfo(); track admin.id) {
                            <li
                                class="rcp-flex rcp-items-center rcp-gap-2 rcp-text-[12px]/9 rcp-font-normal rcp-text-ul-dark-400"
                            >
                                <mat-icon
                                    class="!rcp-h-4 !rcp-w-4 rcp-flex-shrink-0 !rcp-text-base/4 rcp-text-ul-blue-400"
                                    [attr.data-testid]="
                                        admin.testId + '-icon' | testid: testIdPrefix
                                    "
                                    >{{ admin.icon }}</mat-icon
                                >
                                <span
                                    class="rcp-break-all rcp-leading-tight"
                                    [attr.data-testid]="
                                        admin.testId | testid: testIdPrefix
                                    "
                                    >{{ admin.value }}</span
                                >
                            </li>
                        }
                    </ul>

                    <hr class="rcp-my-6" />
                    <!--ACTIVE QR CODE SECTION-->
                    <div
                        *appIsGranted="viewActiveQrRoles()"
                        class="rcp-rounded-large rcp-bg-ul-gray-150 rcp-p-3"
                        [attr.data-testid]="'view-active-qr' | testid: testIdPrefix"
                    >
                        <ul class="rcp-flex rcp-list-outside rcp-flex-col rcp-gap-2">
                            <li
                                class="rcp-flex rcp-items-start rcp-gap-2 rcp-text-[12px] rcp-font-normal rcp-text-ul-dark-400"
                            >
                                <mat-icon
                                    class="!rcp-h-[24px] !rcp-w-[24px] rcp-flex-shrink-0 !rcp-text-base/4 rcp-text-ul-blue-400"
                                    svgIcon="info"
                                    >icon</mat-icon
                                >
                                <div>
                                    <div
                                        class="rcp-mb-1.5 rcp-break-all rcp-font-semibold"
                                        [attr.data-testid]="
                                            'view-active-qr-title' | testid: testIdPrefix
                                        "
                                    >
                                        {{ i18n.QrCodeOnboardingActive }}
                                    </div>
                                    @if (activeQrCodes() > 0) {
                                        <div
                                            class="rcp-break-words rcp-leading-tight"
                                            [attr.data-testid]="
                                                'view-active-qr-description'
                                                    | testid: testIdPrefix
                                            "
                                            [interpolate]="
                                                activeQrCodes() === 1
                                                    ? i18n.ThereIsCurrentlyNoOfActiveQRCodeForOnboarding
                                                    : i18n.ThereAreCurrentlyNoOfActiveQRCodesForOnboarding
                                            "
                                        >
                                            <ng-template
                                                ><b>{{ activeQrCodes() }}</b>
                                            </ng-template>
                                        </div>
                                    } @else {
                                        <div
                                            class="rcp-break-words rcp-leading-tight"
                                            [attr.data-testid]="
                                                'view-active-qr-description'
                                                    | testid: testIdPrefix
                                            "
                                        >
                                            {{
                                                i18n.ThereAreNoActiveQrCodesForOnboarding
                                            }}
                                        </div>
                                    }
                                </div>
                            </li>
                        </ul>
                        <div class="rcp-text-right">
                            <button
                                class="rcp-mt-2"
                                mat-button
                                [attr.data-testid]="
                                    'view-active-qr-codes-btn' | testid: testIdPrefix
                                "
                                (click)="onViewActiveQrCodes($event)"
                            >
                                {{ i18n.ACTION__View }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rcp-flex-auto rcp-overflow-auto">
                <app-navigation [navs]="navs()"></app-navigation>
                <div class="rcp-py-6">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
}
